// A shared tote may mix stores, unless one of its orders carries a store insert
// (a branded box, flyer or promo sample the packer adds at the station). Such an
// order is flagged `single_item_picking_store_bound` by the API and may only share
// the tote with orders of its own store and of the same insert configuration (the
// API's `single_item_picking_insert_signature`); the API rejects anything else with
// `single_item_picking_store_conflict`, so the selection is kept valid here first.

const storeIdOf = order => order?.store?.id ?? order?.store_id

const insertSignatureOf = order => (order?.single_item_picking_insert_signature || []).join(',')

export const canShareSipTote = (order, otherOrder) =>
  storeIdOf(order) === storeIdOf(otherOrder)
    ? insertSignatureOf(order) === insertSignatureOf(otherOrder)
    : !order?.single_item_picking_store_bound && !otherOrder?.single_item_picking_store_bound

// The selected order that blocks `order` from joining the tote, if any.
export const sipToteBlocker = (order, selectedOrders = []) =>
  selectedOrders.find(selected => selected.id !== order.id && !canShareSipTote(order, selected)) || null

// Keeps keys in selection order, dropping each one that cannot share the tote with
// the ones already kept. Covers bulk "select all", which ignores pairwise rules.
export const keepCompatibleSipKeys = (keys = [], ordersByKey = {}) => {
  const kept = []
  keys.forEach(key => {
    const order = ordersByKey[key]
    if (!order) return
    if (sipToteBlocker(order, kept.map(k => ordersByKey[k])) === null) kept.push(key)
  })
  return kept
}

// Names of the inserts that bind the order to its store, for the operator to see which one it carries.
export const insertNames = order => (order?.single_item_picking_insert_names || []).filter(Boolean)
